import React from "react";
import {Row} from "react-bootstrap";
import {RadioGroup} from "../../../genericComponents";

function CustomerSurvey21({serverData}) {
  const [receiveNotification, setReceiveNotification] = React.useState(false);

  React.useEffect(() => {
    if (serverData?.receiveNotification === "Sim") {
      setReceiveNotification(true);
    } else if (serverData?.receiveNotification === "Não") {
      setReceiveNotification(false);
    }
  }, [serverData?.receiveNotification]);

  return (
    <Row>
      <RadioGroup
        name="receiveNotification"
        label="Que tal receber notificações sobre o andamento do seu processo?"
        value={receiveNotification}
        onChange={(event, value) => {
          setReceiveNotification(value);
        }}
        options={[
          {
            label: "Sim",
            value: "Sim",
          },
          {
            label: "Não",
            value: "Não",
          }
        ]}
      />
    </Row>
  );
}

export default React.memo(CustomerSurvey21);
